import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const InlineCode = makeShortcode("InlineCode");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Examples`}</h2>
    <h3>{`File tree navigation without directory links`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<nav aria-label="File navigation">
  <TreeView aria-label="File navigation">
    <TreeView.Item>
      src
      <TreeView.SubTree>
        <TreeView.LinkItem href="#">Avatar.tsx</TreeView.LinkItem>
        <TreeView.Item>
          Button
          <TreeView.SubTree>
            <TreeView.LinkItem href="#" current>
              Button.tsx
            </TreeView.LinkItem>
            <TreeView.LinkItem href="#">Button.test.tsx</TreeView.LinkItem>
          </TreeView.SubTree>
        </TreeView.Item>
      </TreeView.SubTree>
    </TreeView.Item>
    <TreeView.Item>
      public
      <TreeView.SubTree>
        <TreeView.LinkItem href="#">index.html</TreeView.LinkItem>
        <TreeView.LinkItem href="#">favicon.ico</TreeView.LinkItem>
      </TreeView.SubTree>
    </TreeView.Item>
    <TreeView.LinkItem href="#">package.json</TreeView.LinkItem>
  </TreeView>
</nav>
`}</code></pre>
    <h3>{`File tree navigation with directory links`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<nav aria-label="File navigation">
  <TreeView aria-label="File navigation">
    <TreeView.LinkItem href="#">
      src
      <TreeView.SubTree>
        <TreeView.LinkItem href="#">Avatar.tsx</TreeView.LinkItem>
        <TreeView.LinkItem href="#" current>
          Button
          <TreeView.SubTree>
            <TreeView.LinkItem href="#">Button.tsx</TreeView.LinkItem>
            <TreeView.LinkItem href="#">Button.test.tsx</TreeView.LinkItem>
          </TreeView.SubTree>
        </TreeView.LinkItem>
      </TreeView.SubTree>
    </TreeView.LinkItem>
    <TreeView.LinkItem href="#">
      public
      <TreeView.SubTree>
        <TreeView.LinkItem href="#">index.html</TreeView.LinkItem>
        <TreeView.LinkItem href="#">favicon.ico</TreeView.LinkItem>
      </TreeView.SubTree>
    </TreeView.LinkItem>
    <TreeView.LinkItem href="#">package.json</TreeView.LinkItem>
  </TreeView>
</nav>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`TreeView`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" required mdxType="PropsTableRow" />
  {
        /* <PropsTableSxRow /> */
      }
    </PropsTable>
    <h3>{`TreeView.Item`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" required mdxType="PropsTableRow" />
  <PropsTable name="current" type="boolean" defaultValue="false" description="Whether the item is the current item. No more than one item should be current at once." mdxType="PropsTable" />
  <PropsTableRow name="defaultExpanded" type="boolean" description="Whether the item is expanded by default." mdxType="PropsTableRow" />
  <PropsTableRow name="onSelect" type="(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void" mdxType="PropsTableRow" />
  <PropsTableRow name="onToggle" type="(isExpanded: boolean) => void" mdxType="PropsTableRow" />
  {
        /* <PropsTableSxRow /> */
      }
    </PropsTable>
    <h3>{`TreeView.LinkItem`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" required mdxType="PropsTableRow" />
  <PropsTableRow name="href" type="string" description={<>
        The URL that the item navigates to. <InlineCode mdxType="InlineCode">href</InlineCode> is passed to the underlying{' '}
        <InlineCode mdxType="InlineCode">&lt;a&gt;</InlineCode> element. If <InlineCode mdxType="InlineCode">as</InlineCode> is specified, the component may need
        different props. If the item contains a sub-nav, the item is rendered as a{' '}
        <InlineCode mdxType="InlineCode">&lt;button&gt;</InlineCode> and <InlineCode mdxType="InlineCode">href</InlineCode> is ignored.
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="onSelect" type="(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void" mdxType="PropsTableRow" />
  <PropsTableRow name="onToggle" type="(isExpanded: boolean) => void" mdxType="PropsTableRow" />
  {
        /* <PropsTableSxRow /> */
      }
    </PropsTable>
    <h3>{`TreeView.SubTree`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" mdxType="PropsTableRow" />
  {
        /* <PropsTableSxRow /> */
      }
    </PropsTable>
    {
      /* TODO: Add leading and trailing visuals */
    }
    {
      /* ### TreeView.LeadingVisual
      <PropsTable>
       <PropsTableRow
         name="children"
         type={`| React.ReactNode
      | (props: {isExpanded: boolean}) => React.ReactNode`}
       />
       <PropsTableSxRow />
      </PropsTable>
      ### TreeView.TrailingVisual
      <PropsTable>
       <PropsTableRow
         name="children"
         type={`| React.ReactNode
      | (props: {isExpanded: boolean}) => React.ReactNode`}
       />
       <PropsTableSxRow />
      </PropsTable>
      ### TreeView.FolderIcon
      <PropsTable>
       <PropsTableSxRow />
      </PropsTable> */
    }
    {
      /* TODO: Add components to support async behavior (e.g. LoadingItem) */
    }
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: false,
      adaptsToThemes: false,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      